import { ArrowBack, Edit, FilterAlt,Close } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { Link as RouterLink, useNavigate,useLocation } from "react-router-dom";



export const BtnBack = ()=>{

    const navigate = useNavigate();
    
    const goBack = ()=>{
        navigate(-1)
    }

    return(
        
        <IconButton onClick={goBack} sx={{height:50,width:50}}>
            <ArrowBack/>
        </IconButton>
        
    )
}
 // this button apply only inside course component edit button

export const BackBtn = (props)=>{

    const navigate = useNavigate();
    
    const goBackBtn = ()=>{
        navigate(props.link)
    }

    return(
        
        <IconButton onClick={goBackBtn} sx={{height:50,width:50}}>
            <ArrowBack/>
        </IconButton>
        
    )
}

///////////////////----end----///////////

export const BtnClose = (props)=>{

    let func = props.onClickFunc
    const action = (e)=>{
        e.preventDefault()
        func();
    }

    return(
        
            <IconButton onClick={action} sx={{height:50,width:50}}>
                <Close/>
            </IconButton>
        
    )
}


export const FilterBtn = (props)=>{
    let func = props.onClickFunc
    const action = (e)=>{
        e.preventDefault()
        func();
    }
    return(
    <button className="form-btn-3" onClick={func}><FilterAlt/></button>
    )
}

export const BtnPrimary = (props)=>{
   
    return(
        <button disabled={props.disabled} type={props.type} style={props.style} className={`form-btn-2 ${props.addClass}`} onClick={props.action} >
            {props.children}
        </button>
        )
    }

// export const BtnEvent = (props)=>{
   
//         return(
//             <button type={props.type} className={`form-btn-4 ${props.addClass}`} onClick={props.action} >
//                 {props.children}
//             </button>
//             )
//         }

export const BtnSecondarySubmit = (props)=>{
    
    const action=(e)=>{
  
        e.preventDefault();
        props.action();
    }
    return(
        <button className="form-btn-1" onClick={action} >
            {props.children}
        </button>
        )
    }

export const BtnSecondary = (props) =>{
    
    return(
        <button onClick={props.action} disabled={props.disabled} style={props.style} className="form-btn-1">
            {props.children}
        </button>
    )

}